// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ni-2";
export var chatLink = "_ni-0";
export var chatText = "_ni-1";